import { render } from "./Test_DropDowns.vue?vue&type=template&id=8848771a"
import script from "./Test_DropDowns.vue?vue&type=script&lang=js"
export * from "./Test_DropDowns.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__